// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"Subjects_inputSearch__3v0xS","header_modal":"Subjects_header_modal__22jk2","modal":"Subjects_modal__3nCBP"};